import React, { useEffect, useState } from "react";
import style from "./pricing.module.scss";
import Skeleton from "../skeleton/skeleton"

const ListSkeleton = (props) => {

    return <div className={style.wrapper}>
        <h1 style={{ display: 'flex', justifyContent: 'flex-end' }}><Skeleton type='rectangle' width='130px' height='48px' /></h1>
        <div className={style.searchbarWrapper}>
            <Skeleton type='rectangle' width='100%' height='48px' />
        </div>
        <div className={style.dropdownRow}>
            <div className={style.dropdownWrapper}>
                <Skeleton type='rectangle' width='144px' height='44px' />
            </div>
            <div className={style.dropdownWrapper}>
                <Skeleton type='rectangle' width='144px' height='44px' />
            </div>
            <div className={style.dropdownWrapper}>
                <Skeleton type='rectangle' width='144px' height='44px' />
            </div>
            <div className={style.dropdownWrapper}>
                <Skeleton type='rectangle' width='144px' height='44px' />
            </div>
        </div>

        <div className={style.pagination}>
            <div className={style.Dropdown}>
                <div style={{ marginLeft: '15px' }}>
                    <Skeleton type='rectangle' width='184px' height='44px' />
                </div>
                <div style={{ marginLeft: '15px' }}>
                    <Skeleton type='rectangle' width='80px' height='44px' />
                </div>
                <div style={{ marginLeft: '15px' }}>
                    <Skeleton type='rectangle' width='80px' height='44px' />
                </div>
            </div>
        </div>

        <div className={style.newFilterHeaderWrapper}>
            <div style={{ marginLeft: '15px' }}><Skeleton type='rectangle' width='119px' height='36px' /></div>
            <div style={{ marginLeft: '15px' }}><Skeleton type='rectangle' width='119px' height='36px' /></div>
            <div style={{ marginLeft: '15px' }}><Skeleton type='rectangle' width='119px' height='36px' /></div>
            <div style={{ marginLeft: '15px' }}><Skeleton type='rectangle' width='119px' height='36px' /></div>
        </div>

        <div style={{ width: '100%', height: '68px', marginBottom: '15px' }}>
            <Skeleton type='rectangle' width='100%' height='100%' />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '15px' }}>
                <Skeleton type='rectangle' width='100%' height='176px' />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Skeleton type='rectangle' width='100%' height='176px' />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Skeleton type='rectangle' width='100%' height='176px' />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Skeleton type='rectangle' width='100%' height='176px' />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Skeleton type='rectangle' width='100%' height='176px' />
            </div>
        </div>

        <div className={style.paginationTwo}>
            <Skeleton type='rectangle' width='144px' height='44px' />
        </div>

    </div>
}
export default ListSkeleton;
